import React from 'react';

import InstallerAccessRights from '../components/InstallerAccessRights/InstallerAccessRights';

const InstallerAccess = ({ onShowModal, saveButtonDisabled }) => {
    return <InstallerAccessRights onShowModal={onShowModal} saveButtonDisabled={saveButtonDisabled} />;
};

export default InstallerAccess;
